import { render, staticRenderFns } from "./CreateSuccess.vue?vue&type=template&id=79cc6011"
import script from "./CreateSuccess.vue?vue&type=script&lang=js"
export * from "./CreateSuccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports